import {ChargePriceDeltaDto} from '@app/api/dmc';
import {DateCellComponent} from '@shared/components/table/cells/date-cell/date-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';
import {StatusCellComponent} from '@shared/components/table/cells/status-cell/status-cell.component';

export const chargeinformationPriceMasterdata: Columns<ChargePriceDeltaDto>[] = [
  {
    title: 'chargeInformation.dataHub',
    key: 'dataHubStatus',
    cellRenderer: StatusCellComponent,
    cellRendererParams: {
      confirmed: {color: 'bg-green-500', label: 'status.ok'},
      pending: {color: 'bg-yellow-500', label: 'status.pending'},
      pendingJob: {color: 'bg-yellow-500', label: 'status.pending'},
      rejected: {color: 'bg-red-500', label: 'status.inactive'},
      obsolete: {color: 'bg-red-500', label: 'status.obsolete'},
      notapplicable: {color: 'bg-gray-200', label: 'status.notapplicable'},
      notspecified: {color: 'bg-gray-200', label: 'status.notspecified'},
    }
  },
  {
    title: 'chargeprices.validFrom',
    key: 'validFrom',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'chargeprices.validTo',
    key: 'validTo',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'chargeprices.createdBy',
    key: 'createdBy',
  },
  {
    title: 'chargeprices.created',
    key: 'created',
    cellRenderer: DateCellComponent,
  },
];
